var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAchCardLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3553_27084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1875 9.67969H19.797V14.2308H18.1875V9.67969Z",
    stroke: "#2C3E50",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1953 9.67969H15.805V14.2308H14.1953V9.67969Z",
    stroke: "#2C3E50",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1953 9.67969H11.805V14.2308H10.1953V9.67969Z",
    stroke: "#2C3E50",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.21094 9.67969H7.82046V14.2308H6.21094V9.67969Z",
    stroke: "#2C3E50",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50781 7.57422H20.5085V7.85163C20.5085 8.00484 20.3842 8.12905 20.2311 8.12905H5.78523C5.63198 8.12905 5.50781 8.00488 5.50781 7.85163V7.57422Z",
    stroke: "#2C3E50",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52742 15.7891H21.4742C21.6275 15.7891 21.7516 15.9132 21.7516 16.0665V17.4729C21.7516 17.6262 21.6275 17.7503 21.4742 17.7503H4.52742C4.37417 17.7503 4.25 17.6262 4.25 17.4729V16.0665C4.25 15.9132 4.37417 15.7891 4.52742 15.7891Z",
    stroke: "#2C3E50",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6204 5.50711L21.6205 5.50715C21.726 5.57203 21.7757 5.6993 21.742 5.8189C21.7081 5.93832 21.5991 6.02076 21.475 6.02076H4.52737C4.40341 6.02076 4.29437 5.93835 4.26055 5.8189C4.22673 5.69943 4.27629 5.57217 4.38198 5.50708L12.8557 0.291203C12.8557 0.291198 12.8557 0.291193 12.8557 0.291189C12.9451 0.236246 13.0575 0.236306 13.1466 0.291155L13.1466 0.291189L21.6204 5.50711ZM13.3598 2.85214H12.6427C12.2133 2.85214 11.8653 3.20017 11.8653 3.62956C11.8653 4.05894 12.2133 4.40697 12.6427 4.40697H13.3598C13.7892 4.40697 14.1372 4.05894 14.1372 3.62956C14.1372 3.20017 13.7892 2.85214 13.3598 2.85214Z",
    stroke: "#2C3E50",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3553_27084",
    x: 0,
    y: 0,
    width: 26.0039,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3553_27084"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3553_27084",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchCardLogo);
export default __webpack_public_path__ + "static/media/ach_card_logo.a47b6793b0dd53d76e227d49c1b2d88f.svg";
export { ForwardRef as ReactComponent };